var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 16H32V64H64V16Z",
    fill: "#CFD7E9",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V48H32V0Z",
    fill: "#CFD7E9",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 30.3768C37.4427 30.3768 41.855 25.9645 41.855 20.5217C41.855 15.0789 37.4427 10.6667 31.9999 10.6667C26.5571 10.6667 22.1449 15.0789 22.1449 20.5217C22.1449 25.9645 26.5571 30.3768 31.9999 30.3768ZM11.3188 56C10.7665 56 10.3164 55.5514 10.3415 54.9997C10.8642 43.4898 20.361 34.3188 31.9999 34.3188C43.6388 34.3188 53.1357 43.4898 53.6584 54.9996C53.6835 55.5514 53.2334 56 52.6811 56H11.3188Z",
    fill: "#010304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 34.3188V48H11.8414C15.025 39.9853 22.8502 34.3188 31.9989 34.3188H32ZM32 10.6667V30.3768H31.9989C26.5561 30.3768 22.1438 25.9645 22.1438 20.5217C22.1438 15.0789 26.5561 10.6667 31.9989 10.6667H32Z",
    fill: "#26DDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4093 55.1245L56.4131 48.0194L58.6666 50.2402L47.4505 61.3334L37.3333 50.2402L39.829 48.0194L46.0422 55.1245V18.6674L49.4012 18.6667L49.4093 55.1245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality2);
export default __webpack_public_path__ + "static/media/quality_2.e60019836347898475186468f48a6067.svg";
export { ForwardRef as ReactComponent };